// src/components/common/Button.js
import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  to,
  href,
  onClick,
  className = '',
  icon,
  iconPosition = 'right',
  disabled = false,
  type = 'button',
  fullWidth = false,
  ...props
}) => {
  // Determine base styles based on variant
  const getVariantClasses = () => {
    switch (variant) {
      case 'primary':
        return 'bg-primary text-white hover:bg-primary-dark';
      case 'secondary':
        return 'bg-secondary text-white hover:bg-secondary-dark';
      case 'outline-primary':
        return 'border-2 border-primary text-primary hover:bg-primary hover:text-white';
      case 'outline-secondary':
        return 'border-2 border-secondary text-secondary hover:bg-secondary hover:text-white';
      case 'white':
        return 'bg-white text-primary-dark hover:bg-gray-100';
      case 'light':
        return 'bg-transparent border border-white text-white hover:bg-white hover:text-primary-dark';
      case 'text':
        return 'bg-transparent text-primary hover:text-primary-dark underline';
      default:
        return 'bg-primary text-white hover:bg-primary-dark';
    }
  };
  
  // Determine size classes
  const getSizeClasses = () => {
    switch (size) {
      case 'sm':
        return 'text-sm px-3 py-1';
      case 'lg':
        return 'text-lg px-8 py-4';
      case 'md':
      default:
        return 'px-6 py-3';
    }
  };
  
  // Combine all classes
  const buttonClasses = `
    inline-flex items-center justify-center rounded-md font-medium transition-all duration-300
    ${getVariantClasses()}
    ${getSizeClasses()}
    ${fullWidth ? 'w-full' : ''}
    ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
    ${className}
  `;
  
  // Content with icon
  const content = (
    <>
      {icon && iconPosition === 'left' && (
        <span className="mr-2">{icon}</span>
      )}
      {children}
      {icon && iconPosition === 'right' && (
        <span className="ml-2">{icon}</span>
      )}
    </>
  );
  
  // Render based on type (link or button)
  if (to) {
    return (
      <Link to={to} className={buttonClasses} {...props}>
        {content}
      </Link>
    );
  }
  
  if (href) {
    return (
      <a href={href} className={buttonClasses} {...props}>
        {content}
      </a>
    );
  }
  
  return (
    <button
      type={type}
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {content}
    </button>
  );
};

export default Button;









